import { Type } from '@angular/core';
import { CriticaOperadoraIntermediariaComponent } from './conformidade/critica-operadora-intermediaria/critica-operadora-intermediaria.component';
import { RankingCboConsultasComponent } from './indicadores-do-idss/ranking-cbo-consultas/ranking-cbo-consultas.component';
import { ResumoGuiasOutrasOpsComponent } from './conformidade/resumo-guias-outras-ops/resumo-guias-outras-ops.component';
import { ResumoGuiasRedePropriaComponent } from './conformidade/resumo-guias-rede-propria/resumo-guias-rede-propria.component';
import { TabelaTussIncorretaComponent } from './conformidade/tabela-tuss-incorreta/tabela-tuss-incorreta.component';
import { DispersaoUrgenciaEmergenciaComponent } from './analise-rede/dispersao-urgencia-emergencia/dispersao-urgencia-emergencia.component';
import { RpsGuiasUrgenciaEmergenciaComponent } from './analise-rede/rps-guias-urgencia-emergencia/rps-guias-urgencia-emergencia.component';
import { ProcedimentosElegiveisComponent } from './indicadores-do-idss/procedimentos-elegiveis/procedimentos-elegiveis.component';
import { CuidadoDiabeticoComponent } from './indicadores-do-idss/consultas/cuidado-diabetico.component';
import { CuidadoIntegralCriancaComponent } from './indicadores-do-idss/consultas/cuidado-integral-crianca.component';
import { CuidadoIntegralIdosoComponent } from './indicadores-do-idss/consultas/cuidado-integral-idoso.component';
import { CuidadosGengivaNumeradorComponent } from './indicadores-do-idss/consultas/cuidados-gengiva-numerador.component';
import { DiagnosticosInespecificosComponent } from './indicadores-do-idss/consultas/diagnosticos-inespecificos.component';
import { EstimuloPartoProcedimentoComponent } from './indicadores-do-idss/consultas/estimulo-parto-procedimento.component';
import { FraturaIdososComponent } from './indicadores-do-idss/consultas/fraturas-idosos.component';
import { PrevencaoCarieProcedimentosComponent } from './indicadores-do-idss/consultas/prevencao-carie-procedimentos.component';
import { PreventivoCancerUteroComponent } from './indicadores-do-idss/consultas/preventivo-cancer-utero.component';
import { RenalCronicoComponent } from './indicadores-do-idss/consultas/renal-cronico.component';
import { ResumoConsultasEletivasComponent } from './indicadores-do-idss/consultas/resumo-consultas-eletivas.component';
import { ConsultaDentistaComponent } from './indicadores-do-idss/consultas/consulta-denstista.component';
import { RejeitadosReceitaFederalComponent } from './incorporacao-dados/rejeitados-receita-federal/rejeitados-receita-federal.component';
import { GuiasRejeitadasComponent } from './incorporacao-dados/guias-rejeitadas/guias-rejeitadas.component';
import { LancamentosRejeitadosValorPreComponent } from './incorporacao-dados/lancamentos-rejeitados-valor-preestabelecido/lancamentos-rejeitados-valor-preestabelecido.component';
import { LancamentosRejeitadosOutrasDespesasComponent } from './incorporacao-dados/lancamentos-rejeitados-outras-despesas/lancamentos-rejeitados-outras-despesas.component';
import { LancamentosRejeitadosFornecimentoDiretoComponent } from './incorporacao-dados/lancamentos-rejeitados-fornecimento-direto/lancamentos-rejeitados-fornecimento-direto.component';
import { ConsultasMedicasEletivasComponent } from './indicadores-do-idss/consultas-medicas-eletivas/consultas-medicas-eletivas.component';
import { RankingMedicosConsultasComponent } from './indicadores-do-idss/ranking-medicos-consultas/ranking-medicos-consultas.component';
import { ContasRepetidasComponent } from './conformidade/contas-repetidas/contas-repetidas.component';
import { GuiasComPacoteComponent } from './conformidade/guias-com-pacote/guias-com-pacote.component';
import { ModelosRemuneracaoComponent } from './conformidade/modelos-remuneracao/modelos-remuneracao.component';
import { CnesGenericoIncompativelComponent } from './conformidade/cnes-generico-incompativel/cnes-generico-incompativel.component';
import { RelatorioPrestadores210Component } from './analise-rede/relatorio-prestadores-2-10/relatorio-prestadores-2-10.component';
import { PrestadoresAcreditados26Component } from './analise-rede/prestadores-acreditados-2-6/prestadores-acreditados-2-6.component';
import { PrestadoresAcreditados27Component } from './analise-rede/prestadores-acreditados-2-7/prestadores-acreditados-2-7.component';
import { RpsPrestadoresOdontologicosComponent } from './analise-rede/rps-prestadores-odontologicos/rps-prestadores-odontologicos.component';
import { RpsPrestadoresRegistradosComponent } from './analise-rede/rps-prestadores-registrados/rps-prestadores-registrados.component';
// import { CnsRepetidoComponent } from './conformidade/cns-repetido/cns-repetido.component';
// import { CpfRepetidoComponent } from './conformidade/cpf-repetido/cpf-repetido.component';

export interface AnaliseReport {
  path: string;
  name: string;
  descriptionKey: string;
  descriptionValue?: string;
  component: Type<any>;
  category: 'CONFORMIDADE' | 'ANALISE_REDE' | 'INCORPORACAO_DADOS' | 'INDICADORES_IDSS' | 'OUTROS';
}

// Mapeamento completo de TODOS os relatórios organizados por categoria
export const relatoriosList: AnaliseReport[] = [
  // ========== CONFORMIDADE ==========
  {
    path: 'resumo-guias-rede-propria',
    name: 'Resumo guias de rede própria de mesmo CNPJ',
    descriptionKey: 'ANALISES.RESUMO_GUIAS_REDE_PROPRIA',
    component: ResumoGuiasRedePropriaComponent,
    category: 'CONFORMIDADE',
  },
  {
    path: 'resumo-guias-outras-ops',
    name: 'Resumo guias de outras operadoras',
    descriptionKey: 'ANALISES.RESUMO_GUIAS_OUTRAS_OPERADORAS',
    component: ResumoGuiasOutrasOpsComponent,
    category: 'CONFORMIDADE',
  },
  {
    path: 'tabela-tuss-incorreta',
    name: 'Tabela TUSS incorreta para procedimentos TUSS',
    descriptionKey: 'ANALISES.TABELA_TUSS_INCORRETA',
    component: TabelaTussIncorretaComponent,
    category: 'CONFORMIDADE',
  },
  {
    path: 'criticas-operadora-intermediaria',
    name: 'Críticas por operadora intermediária',
    descriptionKey: 'ANALISES.CRITICA_OPERADORA_INTERMEDIARIA',
    component: CriticaOperadoraIntermediariaComponent,
    category: 'CONFORMIDADE',
  },
  {
    path: 'rejeitados-receita-federal',
    name: 'Cruzamento de dados do beneficiário na guia com a Receita Federal',
    descriptionKey: 'ANALISES.REJEITADOS_RECEITA_FEDERAL',
    component: RejeitadosReceitaFederalComponent,
    category: 'CONFORMIDADE',
  },
  {
    path: 'guias-com-pacote',
    name: 'Guias com pacote',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.GUIAS_COM_PACOTE',
    component: GuiasComPacoteComponent,
    category: 'CONFORMIDADE',
  },
  {
    path: 'cnes-generico-incompativel',
    name: 'CNES genérico ou incompatível com o DATASUS',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.CNES_GENERICO_INCOMPATIVEL',
    component: CnesGenericoIncompativelComponent,
    category: 'CONFORMIDADE',
  },
  {
    path: 'contas-repetidas-com-diferentes-chaves',
    name: 'Contas repetidas com diferentes chaves',
    descriptionKey: 'ANALISES.CONTAS_REPETIDAS_COM_DIFERENTES_CHAVES',
    component: ContasRepetidasComponent,
    category: 'CONFORMIDADE',
  },
  {
    path: 'modelos-de-remuneracao',
    name: 'Modelos de remuneração',
    descriptionKey: 'ANALISES.MODELOS_DE_REMUNERACAO',
    component: ModelosRemuneracaoComponent,
    category: 'CONFORMIDADE',
  },

  // ========== ANÁLISE DE REDE ==========
  {
    path: 'dispersao-urgencia-emergencia',
    name: 'Dispersão de urgência e emergência',
    descriptionKey: 'ANALISES.DISPERSAO_URGENCIA_EMERGENCIA',
    component: DispersaoUrgenciaEmergenciaComponent,
    category: 'ANALISE_REDE',
  },
  {
    path: 'rps-guias-urgencia-emergencia',
    name: 'RPS x Guias de urgência e emergência - 2.3',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.RPS_GUIAS_URGENCIA',
    component: RpsGuiasUrgenciaEmergenciaComponent,
    category: 'ANALISE_REDE',
  },
  {
    path: 'relatorio-prestadores-acreditados-2-6',
    name: 'Relatório de prestadores acreditados - 2.6',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.PRESTADORES_ACREDITADOS_2_6',
    component: PrestadoresAcreditados26Component,
    category: 'ANALISE_REDE',
  },
  {
    path: 'relatorio-prestadores-acreditados-2-7',
    name: 'Relatório de prestadores acreditados - 2.7',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.PRESTADORES_ACREDITADOS_2_7',
    component: PrestadoresAcreditados27Component,
    category: 'ANALISE_REDE',
  },
  {
    path: 'rps-prestadores-odontologicos',
    name: 'RPS x Prestadores odontológicos - 2.5',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.RPS_PRESTADORES_ODONTOLOGICOS',
    component: RpsPrestadoresOdontologicosComponent,
    category: 'ANALISE_REDE',
  },
  {
    path: 'relatorio-prestadores-2-10',
    name: 'Relatório de prestadores - 2.10',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.PRESTADORES_2_10',
    component: RelatorioPrestadores210Component, 
    category: 'ANALISE_REDE',
  },
  {
    path: 'rps-prestadores-registrados',
    name: 'RPS - Prestadores registrados',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.RPS_PRESTADORES_REGISTRADOS',
    component: RpsPrestadoresRegistradosComponent,
    category: 'ANALISE_REDE',
  },

  // ========== INCORPORAÇÃO DE DADOS ==========
  {
    path: 'guias-rejeitadas',
    name: 'Guias rejeitadas',
    descriptionKey: 'ANALISES.GUIAS_REJEITADAS',
    component: GuiasRejeitadasComponent,
    category: 'INCORPORACAO_DADOS',
  },
  {
    path: 'lancamentos-rejeitados-valor-preestabelecido',
    name: 'Lançamentos rejeitados de valor preestabelecido',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.LANCAMENTOS_REJEITADOS_VALOR_PREESTABELECIDO',
    component: LancamentosRejeitadosValorPreComponent,
    category: 'INCORPORACAO_DADOS',
  },
  {
    path: 'lancamentos-rejeitados-fornecimento-direto',
    name: 'Lançamentos rejeitados de fornecimento direto',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.LANCAMENTOS_REJEITADOS_FORNECIMENTO_DIRETO',
    component: LancamentosRejeitadosFornecimentoDiretoComponent,
    category: 'INCORPORACAO_DADOS',
  },
  {
    path: 'lancamentos-rejeitados-outras-despesas',
    name: 'Lançamentos rejeitados de outras despesas assistenciais',
    descriptionKey: 'RELATORIOS_PERSONALIZADOS.LANCAMENTOS_REJEITADOS_OUTRAS_DESPESAS',
    component: LancamentosRejeitadosOutrasDespesasComponent,
    category: 'INCORPORACAO_DADOS',
  },

  // ========== INDICADORES IDSS ==========
  {
    path: 'ranking-cbo-consultas',
    name: 'Ranking dos CBOs com consultas eletivas',
    descriptionKey: 'ANALISES.RANKING_CBO_CONSULTAS',
    component: RankingCboConsultasComponent,
    category: 'INDICADORES_IDSS',
  },
  {
    path: 'consultas-medicas-eletivas',
    name: 'Consultas médicas eletivas',
    descriptionKey: 'ANALISES.CONSULTAS_MEDICAS_ELETIVAS',
    component: ConsultasMedicasEletivasComponent,
    category: 'INDICADORES_IDSS',
  },
  {
    path: 'ranking-medicos-consultas',
    name: 'Ranking dos médicos com consultas eletivas',
    descriptionKey: 'ANALISES.RANKING_MEDICOS_CONSULTAS',
    component: RankingMedicosConsultasComponent,
    category: 'INDICADORES_IDSS',
  },
  {
    path: 'procedimentos-elegiveis',
    name: 'Procedimentos elegíveis',
    descriptionKey: 'ANALISES.PROCEDIMENTOS_ELEGIVEIS',
    component: ProcedimentosElegiveisComponent,
    category: 'INDICADORES_IDSS',
  },
  {
    path: 'resumo-consultas-eletivas',
    name: 'Resumo das consultas eletivas',
    descriptionKey: 'CUBOS_ANALISE.METRICAS.RESUMO_CONSULTA_ELETIVA',
    component: ResumoConsultasEletivasComponent,
    category: 'INDICADORES_IDSS',
  },
  //{
    //path: 'estimulo-parto-procedimento',
    //name: '1.1 - Estímulo ao parto normal - por procedimento (numerador e denominador)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.ESTIMULO_PARTO_NORMAL_PROCEDIMENTO',
    //component: EstimuloPartoProcedimentoComponent,
    //category: 'INDICADORES_IDSS',
  //},
  //{
    //path: 'fratura-idosos',
    //name: '1.3 - Fratura em idosos (numerador)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.FRATURA_IDOSOS',
    //component: FraturaIdososComponent,
    //category: 'INDICADORES_IDSS',
  //},
  //{
    //path: 'cuidado-integral-crianca',
    //name: '1.4 - Cuidado integral da criança (numeradores)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.CUIDADO_INTEGRAL_CRIANCA',
    //component: CuidadoIntegralCriancaComponent,
    //category: 'INDICADORES_IDSS',
  //},
  //{
    //path: 'preventivo-cancer-utero',
    //name: '1.5 - Preventivo de câncer de colo do útero (numerador)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.PREVENTIVO_CANCER_COLO_UTERO',
    //component: PreventivoCancerUteroComponent,
    //category: 'INDICADORES_IDSS',
  //},
  {
    path: 'cuidado-diabetico',
    name: '1.6 - Cuidado ao diabético (numerador)',
    descriptionKey: 'CUBOS_ANALISE.METRICAS.CUIDADO_DIABETICO',
    component: CuidadoDiabeticoComponent,
    category: 'INDICADORES_IDSS',
  },
  //{
    //path: 'prevencao-carie-procedimentos',
    //name: '1.7 - Prevenção em odontologia - por procedimentos preventivos (numerador)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.PREVENCAO_CARIE',
    //component: PrevencaoCarieProcedimentosComponent,
    //category: 'INDICADORES_IDSS',
  //},
  //{
    //path: 'cuidados-gengiva-numerador',
    //name: '1.8 - Raspagem supragengival (numerador)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.CUIDADOS_GENGIVA_N',
    //component: CuidadosGengivaNumeradorComponent,
    //category: 'INDICADORES_IDSS',
  //},
  //{
    //path: 'cuidado-integral-idoso',
    //name: '1.9 - Cuidado integral do idoso (numerador e denominador)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.CUIDADO_INTEGRAL_IDOSO',
    //component: CuidadoIntegralIdosoComponent,
    //category: 'INDICADORES_IDSS',
  //},
  //{
    //path: 'renal-cronico',
    //ame: '2.1 - Renal crônico (numerador)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.RENAL_CRONICO',
    //component: RenalCronicoComponent,
    //category: 'INDICADORES_IDSS',
  //},
  //{
    //path: 'consulta-dentista',
    //name: '2.4 - Consulta com dentista (numerador)',
    //descriptionKey: 'CUBOS_ANALISE.METRICAS.CONSULTA_DENTISTA',
    //component: ConsultaDentistaComponent,
    //category: 'INDICADORES_IDSS',
  //},
  {
    path: 'diagnosticos-inespecificos',
    name: '4.5 - Diagnósticos inespecíficos nos eventos de internação (numerador e denominador)',
    descriptionKey: 'CUBOS_ANALISE.METRICAS.DIAGNOSTICOS_INESPECIFICOS',
    component: DiagnosticosInespecificosComponent,
    category: 'INDICADORES_IDSS',
  },
];

export const getReportsByCategory = (category: AnaliseReport['category']) =>
  relatoriosList.filter(report => report.category === category);

export const relatorioMap = relatoriosList.reduce(
  (acc, report) => {
    acc[report.path] = report;
    return acc;
  },
  {} as Record<string, AnaliseReport>,
);
